export var CARD_STYLE_DARK = 'dark';
export var CARD_STYLE_CONSTRUCTOR = 'constructor';
export var CARD_STYLE_YANDEX = 'yandex';
// Вынужденная мера, в дальнейшем уйдет на бек todo
export var content = {
  availableOnlyInOffice: {
    text: 'Для офиса'
  },
  eSim: {
    text: 'eSIM'
  },
  link: {
    text: 'Подробнее',
    constructorText: 'Настроить'
  },
  sharing: {
    plus: '+',
    numbers: ['номер', 'номера', 'номеров']
  }
};